"use client";

import * as React from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";

const emptySubscribe = () => () => {};

function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();

  // Avoids a hydration mismatch: the server can't know the client's
  // preferred/stored theme, so render nothing identifiable until mounted.
  // useSyncExternalStore's getServerSnapshot returns false during SSR and
  // getSnapshot returns true once running on the client -- no effect/setState
  // needed, unlike the common useState+useEffect "mounted" flag pattern.
  const isClient = React.useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );

  if (!isClient) {
    return <Button variant="ghost" size="sm" aria-hidden="true" className="opacity-0" />;
  }

  const isDark = resolvedTheme === "dark";

  return (
    <Button
      variant="ghost"
      size="sm"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onClick={() => setTheme(isDark ? "light" : "dark")}
    >
      {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </Button>
  );
}

export { ThemeToggle };
